<template>
	<b-form @submit="onSubmit">
		<slot></slot>
		<b-overlay no-wrap :show="loading" />
	</b-form>
</template>

<script>
import api from '../../api.js'

export default {
	props: {
		action: {
			type : String,
			required: true
		},
		method: {
			type : String,
			required: true
		},
		params: {
			type : Object,
			required: true
		},
		successCallback: {
			type : Function,
			required: false,
			default: () => { }
		}
	},
	components: { },
	data(){
		return {
			loading:false,
		}
	},
	methods:{
		onSubmit(event){
			event.preventDefault();
			if(this.$listeners.submit){
				this.$listeners.submit(event);
				return;
			}
			this.loading = true;
			let rParams = {
				url:this.action,
				method:this.method,
			}
			if(this.method == 'get'){
				rParams['params'] = this.params
			}else{
				rParams['data'] = this.params
			}
			api(this).request(rParams).then((res) => {
				this.$root.showAlert('OK!')
				this.successCallback(res)
			}).catch((error)=>{
				if(error.response && error.response.status == 422){
					let message = 'Error!'
						Object.keys(error.response.data).forEach(function(key) {
							message = error.response.data[key][0]
						});
					this.$root.showAlert(message,{variant:'danger'})
				}else{
					this.$root.handleRequestError(error)
				}
				this.loading = false;
			}).then(()=>{
				this.loading = false;
			});
		}
	},
	mounted(){
	}
}
</script>

<style>

</style>
